import Tables from "layouts/tables";
import Profile from "layouts/profile";
import QuoteForm from "layouts/quoteForm";
import ContactForm from "layouts/contactForm";
import Subscription from "layouts/subscription";
import JobData from "layouts/jobPage/viewJobs";
import JobApplication from "layouts/jobApplicationForms/viewJobs";
import Videos from "layouts/videoSection/viewVideoData";
import PostBlog from "layouts/viewBlogs";
// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Quote Form",
    key: "quote-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/quote-form",
    component: <QuoteForm />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Conatct Form",
    key: "contact-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/contact-form",
    component: <ContactForm websiteId={"quintustech"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Newsletter",
    key: "newsletter",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/newsletter",
    component: <Subscription websiteId={"quintustech"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Call Back Form",
    key: "call-back-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/call-back-form",
    component: <Tables />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "all-blogs",
    icon: <Icon fontSize="small">Blog</Icon>,
    route: "/all-blogs",
    component: <PostBlog />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Job",
    key: "all-jobs",
    icon: <Icon fontSize="small">Job</Icon>,
    route: "/all-jobs",
    component: <JobData />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Job Applications",
    key: "job-applications",
    icon: <Icon fontSize="small">Job</Icon>,
    route: "/job-applications",
    component: <JobApplication />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Addvideo",
    key: "add-video",
    icon: <Icon fontSize="small">Videos</Icon>,
    route: "/add-video",
    component: <Videos />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <Profile />,
    allowedScopes: ["admin", "hr"],
  },
  {
    type: "collapse",
    name: "QuintusPay",
    key: "QuintusPay",
    icon: <Icon fontSize="small">QuintusPay</Icon>,
    route: "#",
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QuintusPay Conatct Form",
    key: "quintuspay-contact-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/quintusPay-contact-form",
    component: <ContactForm websiteId={"quintusPay"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QuintusPay Newsletter",
    key: "quintuspay-newsletter",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/quintusPay-newsletter",
    component: <Subscription websiteId={"quintuspay"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTExpress",
    key: "QTExpress",
    icon: <Icon fontSize="small">QTExpress</Icon>,
    route: "#",
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTExpress Conatct Form",
    key: "qtexpress-contact-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/qtexpress-contact-form",
    component: <ContactForm websiteId={"qtexpress"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTExpress Newsletter",
    key: "qtexpress-newsletter",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/qtexpress-newsletter",
    component: <Subscription websiteId={"qtexpress"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTCollector",
    key: "QTCollector",
    icon: <Icon fontSize="small">QTCollector</Icon>,
    route: "#",
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTCollector Conatct Form",
    key: "qtcollector-contact-form",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/qtcollector-contact-form",
    component: <ContactForm websiteId={"qtcollector"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "QTCollector Newsletter",
    key: "qtcollector-newsletter",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/qtcollector-newsletter",
    component: <Subscription websiteId={"qtcollector"} />,
    allowedScopes: ["admin"],
  },
  {
    type: "collapse",
    name: "HR Payslips",
    key: "pay-slip",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/pay-slip",
    component: null,
    allowedScopes: ["hr"],
  },
];

export default routes;
